export default __webpack_public_path__ + "static/media/TextSummarizer.4b127402.gif";